import english from './resources/en.json'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import relativeTime from 'dayjs/plugin/relativeTime'

// Configure dayjs plugins
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(localizedFormat)
dayjs.extend(relativeTime)

const allResources = {
  en: english,
  // Add more languages here: de: german, fr: french, etc.
}

export const selectLanguage = () => {
  const currentLang = navigator.language.split(/[-_]/)[0]
  let lang = currentLang
  let resources = allResources[currentLang]

  if (resources === undefined || Object.keys(resources).length === 0) {
    resources = allResources['en']
    lang = 'en'
  }

  return { lang, resources }
}
